import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
const TOKEN_KEY = "cambroo_customer_token";

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY) || "");
  const [customer, setCustomer] = useState(undefined); // undefined = checking

  useEffect(() => {
    if (!token) {
      setCustomer(null);
      return;
    }
    api
      .get("/auth/me", { Authorization: `Bearer ${token}` })
      .then((c) => setCustomer(c))
      .catch(() => {
        localStorage.removeItem(TOKEN_KEY);
        setToken("");
        setCustomer(null);
      });
  }, [token]);

  const login = async (email, password) => {
    const d = await api.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, d.token);
    setToken(d.token);
    setCustomer(d.customer);
  };

  const register = async (name, email, password, phone) => {
    const d = await api.post("/auth/register", { name, email, password, phone });
    localStorage.setItem(TOKEN_KEY, d.token);
    setToken(d.token);
    setCustomer(d.customer);
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setToken("");
    setCustomer(null);
  };

  const authHeaders = () => (token ? { Authorization: `Bearer ${token}` } : {});

  return (
    <AuthContext.Provider value={{ customer, token, login, register, logout, authHeaders }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
